define(
	'DC.ItemGroup.Details.View.Extension'
,   [
        'dc_item_group_detail.tpl',
        'Backbone',
        'Backbone.CollectionView',
        'DC.ItemGroupCustomization.Main.SS2Model',
        'Item.Model',
        'ProductDetails.ImageGallery.View',
        'DC.Item.Group.Component.View',
        'AjaxRequestsKiller',
        'jQuery',
        'Utils',
        'underscore'
	]
,   function (
        dc_item_group_detail_tpl,
        Backbone,
        BackboneCollectionView,
        ItemGroupModel,
        ProductModel,
        ProductDetailsImageGalleryView,
        ItemGroupComponentView,
        AjaxRequestsKiller,
        jQuery,
        Utils,
        _
	)
{
	'use strict';

    return Backbone.View.extend({
        template: dc_item_group_detail_tpl,

        initialize: function (options) {
            this.itemGroupId = options.routerArguments[0];
            this.container = options.container;
        },

        beforeShowContent: function(){
            var self = this;
            var itemGroupModel = new ItemGroupModel();

            return itemGroupModel.fetch({
                killerId: AjaxRequestsKiller.getKillerId(),
                data: {itemId: this.itemGroupId}
            }).then(function(response){
                var search = self.container.getComponent("Search");
                var searchParams = {
                    id: _.pluck(response.itemgroups[self.itemGroupId].components, 'internalid').join(','),
                    fieldset: "search"
                };
                var searchUrl = search.getUrl(searchParams);
                if(searchParams.id){
                    jQuery.ajax({
                        url: searchUrl,
                        async: false,
                        success: function(response){
                            self.components = response.items || [];
                        }
                    })
                }

                if(response && response.itemgroups){
                    var itemData = response.itemgroups[self.itemGroupId];
                    itemData.itemimages_detail = {image: { altimagetext:itemData.itemId, url: itemData.itemimage }}
                    self.model = new ProductModel(itemData);
                }
            });
        },

        events: {
            'click [data-action=add-item-group-to-cart]': 'addItemGroupToCart'
        },

        addItemGroupToCart: function(){
            if(this.model.get('components')){
                var cart = this.container.getComponent("Cart");
                var igQuantity = this.$('[name="ig-quantity"]').val() || 1;
                var lines = _.map(this.model.get('components'), function(line){
                    return {
                        quantity: parseInt(line.quantity) * igQuantity,
                        item: {
                            internalid: line.internalid
                        }
                    }
                });
                cart.addLines({lines: lines}).then(function() {
                    cart.triggerAddToCartConfirmation().then(function() {
                        console.log('Lines successfully added to cart.');
                    })
                });
            }
        },

        childViews: {
            'Product.ImageGallery': function() {
                return new ProductDetailsImageGalleryView({
                    model: this.model,
                    application: this.options.application
                });
            },
            'Item.Group.Components': function() {
                return new BackboneCollectionView({
                    childView: ItemGroupComponentView,
                    collection: this.components,
                    childViewOptions: {
                        application: this.options.application,
                        container: this.container
                    }
                });
            }
        },

        getContext: function(){
            return {
                sku: this.model.get('_sku'), 
                description: this.model.get('description')
            }
        }
    });
	
});
